<template>
  <div>
    <homelogo />
    <v-img width="100%" src="@/assets/comoLoHacemos/como_lo_hacemos/como_lo_hacemos.jpg">
      <span class="leftButton">
        <v-btn large rounded color="orange" class="r-btn" @click="onclickreturn()">
          <b class="white--text">Nuestra escencia</b>
        </v-btn>
      </span>
    </v-img>
    <br />
    <br />
    <v-row id="init">
      <v-col v-for="(link, i) in items" :key="i" cols="6" xl="3" lg="3" md="3" sm="6" xs="6">
        <v-row>
          <v-col cols="12" class="text-center" style="paddign:0">
            <!-- <span class="img-container"> -->
              <a :href="`#${link.href}`">
                <v-img
              max-width="100%"
              :src="require(`@/assets/comoLoHacemos/como_lo_hacemos/${link.icon}.png`)"
            ></v-img>
              </a>
            
            <!-- </span> -->

            <p style="color:orange">{{link.text}}</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row id="raee" class="box-center" style="padding:0">
      <v-col lg="6" md="6" sm="12" cols="12" class="px-12" style="padding:0">
        <h1 class="titles" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">RAEE</h1>
        <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
          La principal materia prima que emplea nuestra Fundación 
          para el desarrollo de sus programas sociales, es el RAEE, 
          los cuales son todos los aparatos eléctricos o electrónicos 
          que se desechan o descartan al final de su vida útil, revisa 
          a continuación cuáles gestionamos desde la fundación.
          <!-- Para lograr el objeto social de nuestra fundación
          utilizamos los Residuos de Aparatos Eléctricos o
          Electrónicos -RAEE- los cuales son dispositivos
          que se convierten en Residuos cuando se acerca
          al final de su "vida útil", muchos de estos
          productos se pueden reutilizar, restaurar o reciclar -->
        </p>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12" style="padding:0">
        <v-img src="@/assets/comoLoHacemos/RAE/raee.jpg"></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="(link, i) in itemsRaee"
        :key="i"
        cols="12"
        xl="6"
        lg="6"
        md="6"
        sm="12"
        xs="12"
        style="padding:0"
      >
        <!-- <v-card-text class="text-center"> -->
        <v-row>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6" style="padding:0">
            <v-img :src="require(`@/assets/comoLoHacemos/RAE/${link.icon}.png`)"></v-img>
          </v-col>
          <v-col
            cols="12"
            xl="6"
            lg="6"
            md="6"
            sm="6"
            class="floatcenter"
            style="text-align: center; padding:0"
          >
            <h1 class="titles5 font-weidth-black">{{link.text}}</h1>
          </v-col>
        </v-row>
        <!-- </v-card-text> -->
      </v-col>
    </v-row>
    <v-row v-if="imageHeight=='xs'|imageHeight=='sm'" style="padding:0">
      <v-col cols="12" class="text-center">
        <a href="#" @click="onclickreturn()" style="display: inline-block;" width="150px">
          <v-img width="150px" src="@/assets/comoLoHacemos/como_lo_hacemos/flecha_1.png"></v-img>
        </a>
      </v-col>
    </v-row>
    <v-row id="reacondicionar">
      <v-col
        lg="6"
        md="6"
        sm="12"
        class="floatcenter"
        :style="imageHeight!='xs'&imageHeight!='sm'?`padding:9%`:`padding:3%`"
      >
        <v-row>
          <v-col cols="12">
            <h1
              class="titles"
              :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'"
            >Reacondicionamiento</h1>
          </v-col>

          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Según nuestras leyes nacionales, la LEY 1672 DE
              2013 define el Reacondicionamiento como el
              Procedimiento técnico de renovación, en el cual se
              restablecerá las condiciones funcionales y
              estéticas de un dispositivo eléctrico y electrónico
              con el fin de ser usado en un nuevo ciclo de vida.
              Puede implicar además reparación, en caso de que
              el equipo posea algún daño.
            </p>
          </v-col>
        </v-row>
      </v-col>

      <div class="btn-arrow pa-0" v-if="imageHeight!='xs'&imageHeight!='sm'">
        <v-btn fab absolute @click="onclickreturn()">
          <v-img max-width="100%" src="@/assets/comoLoHacemos/como_lo_hacemos/flecha_1.png"></v-img>
        </v-btn>
      </div>
      <v-col lg="6" md="6" sm="12" style="padding:0%;">
        <v-img src="@/assets/comoLoHacemos/reacondicionar/reacondicionarte.jpg" width="100%"></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="6" md="6" sm="12" cols="12" style="padding:0%;">
        <v-img src="@/assets/comoLoHacemos/reacondicionar/tecnicos_ingenieros.jpg"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12" class="floatcenter">
        <p class="parrafos1 px-12 text-center">
          El compromiso social y ambiental de la Fundación PC SHEK Colombia, 
          hace que cada día se trabaje por llegar a más sectores de la sociedad 
          que requieren de este tipo de tecnología y vean en ellos una alternativa 
          de trabajo, estudio, capacitación, ingresos económicos, apoyo social, entre otros.
          <!-- Técnicos e ingenieros trabajan arduamente
          restaurando diferentes equipos electronicos hasta
          devolverlos a su vida útil. -->
        </p>
      </v-col>
    </v-row>
    <v-row v-if="imageHeight=='xs'|imageHeight=='sm'">
      <v-col cols="12" class="text-center">
        <a href="#" @click="onclickreturn()" style="display: inline-block;" width="150px">
          <v-img width="150px" src="@/assets/comoLoHacemos/como_lo_hacemos/flecha_1.png"></v-img>
        </a>
      </v-col>
    </v-row>
    <v-row id="economiaCircular" style="paddign:0">
      <v-col
        lg="6"
        md="6"
        sm="12"
        class="floatcenter"
        :style="imageHeight!='xs'&imageHeight!='sm'?`padding:9%`:`padding:2%`"
      >
        <v-row>
          <v-col cols="12" style="paddign:0">
            <h1
              class="titles"
              :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'"
            >Economía circular</h1>
          </v-col>

          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Nuestra fundación se acoge al modelo de Economía Circular, 
              logrando que los materiales y componentes de los Residuos 
              de Aparatos Eléctricos se mantengan durante el mayor tiempo posible, 
              de esta manera fomentamos el reacondicionamiento, la reutilización y 
              el reciclaje de tecnología dada de baja, haciendo una apuesta social 
              y ambiental que pocas organizaciones están desarrollando en el país, 
              por esta razón las instituciones tanto públicas como privadas que buscan 
              apoyar esta labor social, pueden ver en la Fundación PC SHEK Colombia, 
              una alternativa eficiente, actualizada y capacitada para cumplir cualquier
              requerimiento que dé respuesta a este iniciativa social.
              <!-- Nuestra fundación se acoge al modelo de Economía
              Circular cuyo objetivo es el valor de los materiales y
              recursos de los Residuos de Aparatos Eléctricos y se
              mantiene durante el mayor tiempo posible y se
              reduce al mínimo la generación de residuos.
              De esta manera fomentamos el reacondicionamiento,
              la reutilización y el reciclaje de tecnología dada de
              baja haciendo una apuesta social y ambiental.
              La Fundación PC SHEK Colombia ,es eficiente,
              actualizada y capacitada para cumplir cualquier
              requerimiento que responda a esta iniciativa social. -->
            </p>
          </v-col>
        </v-row>
      </v-col>
      
      <div
        class="text-center btn-arrow"
        style="display:absolute"
        v-if="imageHeight!='xs'&imageHeight!='sm'"
      >
        <v-btn fab absolute @click="onclickreturn()">
          <v-img max-width="100%" src="@/assets/comoLoHacemos/como_lo_hacemos/flecha_1.png"></v-img>
        </v-btn>
      </div>
      <v-col lg="6" md="6" sm="12" style="padding:0%;">
        <v-img src="@/assets/comoLoHacemos/economia_circular/economia_circular.jpg"></v-img>
      </v-col>
      <v-col cols="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/infografia.jpg"></v-img>
         <div class="cardBottom text-center">
        <p>Concepto de la economía circular por la que propende la gestión integral de los RAEE</p>
        <p style="text-decoration:none solid rgb(255, 255, 255)">Fuente: Ministerio de Ambiente</p>
        <p> https://www.minambiente.gov.co/images/AsuntosambientalesySectorialyUrbana/pdf/e-book_rae_/contenido_5_1.html</p>
        </div>
      </v-col>
    </v-row>
    <v-row class="hidden-sm-and-down">
      <v-col lg="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/recuperacion_reparacion.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="floatcenter" style="padding:1% 10%">
        <v-row>
          <v-col cols="12">
            <h1
              class="titles3"
              :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'"
            >Recuperación y reparación.</h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Políticas avanzadas de recuperación y reparación
              para fomentar el reciclaje y la integración
              del contenido reciclado en nuevos productos.
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="hidden-sm-and-down">
      <v-col lg="6" md="6" sm="12" class="floatcenter" style="padding:1% 10%">
        <v-row>
          <v-col cols="12">
            <h1
              class="titles2"
              :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'"
            >Reciclaje.</h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Con la ayuda de reformas y reparaciones
              avanzadas y mercados de segunda mano
              eficientes, se extiende la durabilidad del equipo y
              tienen una segunda o tercera vida útil .
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col lg="6" md="6" sm="12" xs="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/reciclaje.png"></v-img>
      </v-col>
    </v-row>
    <v-row class="hidden-sm-and-down">
      <v-col lg="6" md="6" sm="12" xs="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/innovacion_desarrollo.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="floatcenter" style="padding:1% 10%">
        <v-row>
          <v-col cols="12">
            <h1 class="titles3" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Innovación y desarrollo
              I+D.
            </h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Laboratorios especializados , servicio de
              sostenibilidad, seguridad de la información,
              economía y cumplimiento de la legislación.
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="hidden-sm-and-down">
      <v-col lg="6" md="6" sm="12" class="floatcenter" style="padding:1% 10%">
        <v-row>
          <v-col cols="12">
            <h1 class="titles2" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Fabricación y
              Reelaboración.
            </h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Eco-diseño : productos diseñados para
              durabilidad, reutilización
              y reciclaje seguro.
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col lg="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/fabricacion.png"></v-img>
      </v-col>
    </v-row>
    <v-row class="hidden-sm-and-down">
      <v-col lg="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/distribucion.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="floatcenter" style="padding:1% 10%">
        <v-row>
          <v-col cols="12">
            <h1
              class="titles3"
              :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'"
            >Distribución y trasporte.</h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Gestión optimizada de los flujos de materiales,
              energias y servicios.
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="hidden-sm-and-down">
      <v-col lg="6" md="6" sm="12" class="floatcenter" style="padding:1% 10%">
        <v-row>
          <v-col cols="12">
            <h1 class="titles2" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Uso y consumo
              responsable.
            </h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              El consumidor final gestionara de manera correcta
              y respetuosa con el medio ambiente los residuos
              de aparatos eléctricos y electrónicos (RAEE).
            </p>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/consumo_responsable.png"></v-img>
      </v-col>
    </v-row>
    <v-row class="hidden-md-and-up">
      <v-col lg="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/recuperacion_reparacion.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="floatcenter" style="padding:9%">
        <v-row>
          <v-col cols="12">
            <h1
              class="titles3"
              :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'"
            >Recuperación y reparación.</h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Políticas avanzadas de recuperación y reparación
              para fomentar el reciclaje y la integración
              del contenido reciclado en nuevos productos.
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col lg="6" md="6" sm="12" xs="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/reciclaje.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="floatcenter" style="padding:9%">
        <v-row>
          <v-col cols="12">
            <h1
              class="titles2"
              :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'"
            >Reciclaje.</h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Con la ayuda de reformas y reparaciones
              avanzadas y mercados de segunda mano
              eficientes, se extiende la durabilidad del equipo y
              tienen una segunda o tercera vida útil .
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col lg="6" md="6" sm="12" xs="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/innovacion_desarrollo.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="floatcenter" style="padding:9%">
        <v-row>
          <v-col cols="12">
            <h1 class="titles3" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Innovación y desarrollo
              I+D.
            </h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Laboratorios especializados , servicio de
              sostenibilidad, seguridad de la información,
              economía y cumplimiento de la legislación.
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col lg="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/fabricacion.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="floatcenter" style="padding:9%">
        <v-row>
          <v-col cols="12">
            <h1 class="titles2" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Fabricación y
              Reelavoración.
            </h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Eco-diseño : productos diseñados para
              durabilidad, reutilización
              y reciclaje seguro.
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col lg="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/distribucion.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="floatcenter" style="padding:9%">
        <v-row>
          <v-col cols="12">
            <h1
              class="titles3"
              :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'"
            >Distribución y trasporte.</h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Gestión optimizada de los flujos de materiales,
              energias y servicios.
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/economia_circular/consumo_responsable.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="floatcenter" style="padding:9%">
        <v-row>
          <v-col cols="12">
            <h1 class="titles2" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Uso y consumo
              responsable.
            </h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              El consumidor final gestionara de manera correcta
              y respetuosa con el medio ambiente los residuos
              de aparatos eléctricos y electrónicos (RAEE).
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="imageHeight=='xs'|imageHeight=='sm'">
      <v-col cols="12" class="text-center">
        <a href="#" @click="onclickreturn()" style="display: inline-block;" width="150px">
          <v-img width="150px" src="@/assets/comoLoHacemos/como_lo_hacemos/flecha_1.png"></v-img>
        </a>
      </v-col>
    </v-row>
    <v-row id="comoLoHacemos">
      <v-col
        lx="12"
        lg="6"
        md="6"
        sm="12"
        cols="12"
        class="floatcenter"
        :style="imageHeight!='xs'&imageHeight!='sm'?`padding:9%`:`padding:1%`"
      >
        <v-row>
          <v-col cols="12">
            <h1
              class="titles2"
              style="color:orange"
              :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'"
            >Cómo lo hacemos</h1>
          </v-col>
          <v-col cols="12">
            <p class="parrafos1" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              La Fundación PC SHEK Colombia cuenta con
              profesionales capacitados en la parte técnica y
              electrónica, quienes desde nuestros laboratorios
              se logran restaurar, reacondicionar y poner a
              prueba aquellos equipos que han sido dados de
              bajo por fallas en su funcionamiento o por
              obsolescencia. Luego, de una revisión técnica se
              determina qué dispositivos pueden ser reacondicionados para su posterior donación.
              El compromiso social y ambiental de la Fundación
              PC SHEK Colombia , hace que cada día se trabaje
              por llegar a más sectores de la sociedad que
              requieren de este tipo de tecnología y vean en
              ellos una alternativa de trabajo, estudio,
              capacitación, entre otros.
            </p>
          </v-col>
        </v-row>
      </v-col>

      <div class="btn-arrow" v-if="imageHeight!='xs'&imageHeight!='sm'">
        <v-btn fab absolute @click="onclickreturn()">
          <v-img max-width="100%" src="@/assets/comoLoHacemos/como_lo_hacemos/flecha_1.png"></v-img>
        </v-btn>
      </div>
      <v-col cols="12" xl="6" lg="6" md="6" sm="12" style="padding:0">
        <v-img
          width="100%"
          style="padding:0"
          src="@/assets/comoLoHacemos/como_lo_hacemos_link/como_lo_hacemos.jpg"
        ></v-img>
      </v-col>
    </v-row>
    <v-row class="hidden-sm-and-down box-center">
      <v-col lg="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/como_lo_hacemos_link/recolectamos.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="text-center">
        <h1 class="titles5" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
          Recolectamos todos los
          residuos, electrónicos de las
          empresas.
        </h1>
      </v-col>
    </v-row>
    <v-row class="hidden-sm-and-down box-center">
      <v-col lg="6" md="6" sm="12" class="text-center">
        <h1 class="titles5" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
          Nuestros técnicos e
          ingenieros los restauran
          devolviéndolos a la vida útil.
        </h1>
      </v-col>
      <v-col lg="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/como_lo_hacemos_link/restauran.png"></v-img>
      </v-col>
    </v-row>
    <v-row class="hidden-sm-and-down box-center">
      <v-col lg="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/como_lo_hacemos_link/entrega.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="text-center">
        <v-row>
          <v-col>
            <h1 class="titles5" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Hacemos entrega de estos
              equipos reacondicionados a
              instituciones que trabajen
              con primera infancia.
            </h1>
          </v-col>
          <v-col cols="12">
            <a href="#" @click="onclickreturn()" style="display: inline-block;" width="150px">
              <v-img width="150px" src="@/assets/comoLoHacemos/como_lo_hacemos/flecha_1.png"></v-img>
            </a>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="hidden-md-and-up box-center">
      <v-col lg="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/como_lo_hacemos_link/recolectamos.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="text-center">
        <h1 class="titles5" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
          Recolectamos todos los
          residuos, electrónicos de las
          empresas.
        </h1>
      </v-col>
      <v-col lg="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/como_lo_hacemos_link/restauran.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="text-center">
        <h1 class="titles5" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
          Nuestros técnicos e
          ingenieros los restauran
          devolviéndolos a la vida útil.
        </h1>
      </v-col>
      <v-col lg="6" md="6" sm="12">
        <v-img src="@/assets/comoLoHacemos/como_lo_hacemos_link/entrega.png"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" class="text-center">
        <v-row>
          <v-col>
            <h1 class="titles5" :class="imageHeight!='xs'&&imageHeight!='sm'?``:'text-center'">
              Hacemos entrega de estos
              equipos reacondicionados a
              instituciones que trabajen
              con primera infancia.
            </h1>
          </v-col>
          <v-col cols="12" class="text-center align-center">
            <a href="#" @click="onclickreturn()" style="display: inline-block;" width="150px">
              <v-img width="150px" src="@/assets/comoLoHacemos/como_lo_hacemos/flecha_1.png"></v-img>
            </a>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import homelogo from "@/components/homelogo/homelogo.vue";
export default {
  components: {
    homelogo
  },
  data: () => ({
    items: [
      {
        text: "Cómo lo hacemos.",
        icon: "como_lo_hacemos_link2",
        href: "comoLoHacemos"
      },
      {
        text: "RAEE.",
        icon: "raee_link",
        href: "raee"
      },
      {
        text: "Reacondicionamiento.",
        icon: "reacondicionarte_link",
        href: "reacondicionar"
      },
      {
        text: "Economia circular.",
        icon: "economia_circular_link",
        href: "economiaCircular"
      },
    ],
    itemsRaee: [
      {
        icon: "grandres_electrodomesticos",
        text: "Grandes Electrodomésticos."
      },
      {
        icon: "equipos_informaticos",
        text: "Equipos informáticos y telecomunicación."
      },
      {
        icon: "pequenos_electrodomesticos",
        text: "Pequeños Electrodomésticos"
      },
      {
        icon: "aparatos_electronicos",
        text: "Aparatos electrónicos de consumo."
      },
      { icon: "herramientas_electricas", text: "Herramientas eléctricas." }
    ]
  }),
  computed: {
    imageHeight() {
      return this.$vuetify.breakpoint.name;
    }
  },
  methods: {
    onClick(e, item) {
      e.stopPropagation();

      if (item.to || !item.href) return;

      this.$vuetify.goTo(item.href.endsWith("!") ? 0 : item.href);
    },
    onclickreturn() {
      this.$vuetify.goTo("#init");
    }
  }
};
</script>
<style scoped>
v-col {
  padding: 0;
}
v-row {
  padding: 0;
}
.floatcenter {
  display: flex;
  display: -webkit-flex;
  margin: auto;
}

.floatcentertext {
  text-align: center;
  margin: auto;
}

.btn-arrow-right {
  /* display: flex; */
  text-align: right;
  display: flex;
  justify-content: right;
  padding-right: 50%;
  padding-top: 5%;
  /* justify-content: right; */
}
.btn-arrow {
  display: flex;
  justify-content: center;
}
.leftButton {
  position: absolute;
  padding-top: 23%;
  left: 4%;
  scroll-padding-bottom: 40%;
  /* top: 40%;
  left: 10%; */
  width: 25%;
}
.img-container {
  text-align: center;
  display: block;
}
@media (max-width: 880px) {
  .leftButton {
    position: absolute;
    padding-top: 18%;
    left: 3%;
    /* padding-left: %; */
    /* scroll-padding-bottom: 25%; */
    /* top: 40%;
  left: 10%; */
    width: 25%;
  }
  .r-btn {
    font-size: 15pt !important;
    height: 57px !important;
  }
}
@media (max-width: 545px) {
  .leftButton {
    position: absolute;
    padding-top: 1%;
    left: 10%;
    /* padding-left: %; */
    /* scroll-padding-bottom: 25%; */
    /* top: 40%;
  left: 10%; */
    width: 25%;
  }
  .r-btn {
    font-size: 12pt !important;
    height: 48px !important;
  }
}
</style>